import React, { Dispatch, SetStateAction, useState } from "react";
import CommonInputTwo from "../CommonForms/CommonInputTwo";
import { Col, Row } from "antd";
import classes from "./Filter.module.css";
import { lengths } from "../../Shared/Constants";
import {
  FilterValuesCheck,
  Phone_Number_Validation,
  TrimStart,
  ValidinputData,
} from "../../Shared/Methods";
import CommonButton from "../Buttons/CommonButton";

interface props {
  showfilter: boolean;
  pageSize: number;
  pageind: number;
  GetList: (page: number, size: number, values: any) => void;
  setpageSize: Dispatch<SetStateAction<number>>;
  setPageInd: Dispatch<SetStateAction<number>>;
  ResetForm: () => void;
}

function FilterUser({
  showfilter,
  pageSize,
  pageind,
  GetList,
  setpageSize,
  setPageInd,
  ResetForm,
}: props) {
  const [values, setvalues] = useState({
    name: "",
    mobile_no: "",
  });

  return (
    <>
      {showfilter ? (
        <div className={classes.filter_container}>
          <Row gutter={[16, 16]}>
            <Col xl={6} lg={8} md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="name"
                labelname="Name"
                value={values.name}
                onChange={(e) => {
                  setvalues({
                    ...values,
                    name: TrimStart(e.target.value),
                  });
                }}
                maxLength={lengths?.Names}
              />
            </Col>

            <Col xl={6} lg={8} md={8} sm={12} xs={24}>
              <CommonInputTwo
                name="mobile_no"
                labelname="Mobile"
                value={values.mobile_no}
                onChange={({ target }) => {
                  Phone_Number_Validation(target) &&
                    setvalues({
                      ...values,
                      mobile_no: ValidinputData(target.value),
                    });
                }}
                maxLength={lengths?.Mobile}
              />
            </Col>
            <Col
              xl={6}
              lg={8}
              md={8}
              sm={12}
              xs={24}
              className="d-flex align-items-end"
            >
              <CommonButton
                name="Search"
                onClick={() => GetList(1, pageSize, values)}
                type="Submit"
                classname="submit_btn"
                disabled={FilterValuesCheck(values)}
              />
              &nbsp;&nbsp;
              <CommonButton
                name="Reset"
                onClick={() => {
                  setvalues({ name: "", mobile_no: "" });
                  ResetForm();
                }}
                // style={{ color: "white", backgroundColor: "#0084ff" }}
                type="button"
                classname="reset_btn"
                disabled={FilterValuesCheck(values)}
              />
            </Col>
          </Row>
        </div>
      ) : null}
    </>
  );
}

export default FilterUser;
